import React, {memo, useCallback, useMemo, useState} from 'react';

import './index.scss';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {useSelector} from 'react-redux';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {IntercomModel} from '../../../../types/intercom';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useLocalization} from "../../../../hooks/localization";


const keyExtractor = (item: IntercomModel) => item.id;

export const IntercomListScreen = memo(function IntercomListScreen() {
    const {t} = useLocalization();
    const doorSet = useSetSelector(state => state.control.doorList);
    const intercomList = useSelector(state => state.control.intercomList);

    const [selectedIntercom, setSelectedIntercom] = useState<IntercomModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/settings/intercom/edit/${selectedIntercom ? selectedIntercom.id : ''}`,
            className: 'orange',
            hidden: !(selectedIntercom),
        },
        {
            text: t('create_intercom'),
            url: '/settings/intercom/edit',
            className: 'green',
        },
    ], [t, selectedIntercom]);


    const displayNameExtractor = useCallback((item: IntercomModel, column: ColumnModel) => {
        if (column.key === 'door_id_list') {
            return item.door_id_list.map(id => doorSet[id].name).join(', ');
        }

        return item[column.key] || '-';
    }, [doorSet]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('INTERCOM_NAME'),
            key: 'name',
        },
        {
            length: 1,
            name: 'SIP',
            key: 'sip_id',
        },
        {
            length: 3,
            name: t('DOORS'),
            key: 'door_id_list',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} className="camera-list-page" backUrl={'/settings'}>
                <SettingsList
                    columns={columns}
                    items={intercomList}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedIntercom}
                    onItemSelected={setSelectedIntercom}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
